import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import {
  PipelinedetailsStoreActions,
  PipelinedetailsStoreSelectors,
  PipelinedetailsStoreReducer,
} from "./index";
import { PipelineDetailsDto } from "@cradua/data";

@Injectable()
export class PipelinedetailsFacade {
  constructor(
    private store: Store<PipelinedetailsStoreReducer.PipelinedetailsPartialState>,
  ) {}

  Pipelinedetails$ = this.store.select(
    PipelinedetailsStoreSelectors.getLastInsertedValue,
  );
  PipelinedetailsError$ = this.store.select(
    PipelinedetailsStoreSelectors.getPipelinedetailsError,
  );
  searchedPipelinedetails$ = this.store.select(
    PipelinedetailsStoreSelectors.getSearchPipelinedetails,
  );

  loadRegister$ = this.store.select(
    PipelinedetailsStoreSelectors.getAllPipelinedetails,
  );

  // return this.store.select(PipelinedetailsStoreSelectors.getAllPipelinedetails);

  getselected() {
    return this.store.select(PipelinedetailsStoreSelectors.getSelected);
  }

  isLoadingPipelinedetails(query) {
    this.store.dispatch(
      PipelinedetailsStoreActions.fetchPipelinedetailsRecord({ fetch: query }),
    );
    return this.store.select(PipelinedetailsStoreSelectors.loadingPipelinedetails);
  }

  isLoadingPipelinedetailsById(id: string) {
    this.store.dispatch(
      PipelinedetailsStoreActions.fetchByIdPipelinedetailsRecord({ id }),
    );
    return this.store.select(PipelinedetailsStoreSelectors.loadingPipelinedetails);
  }

  get loadPipelinedetails() {
    this.store.dispatch(PipelinedetailsStoreActions.loadPipelinedetails());
    return this.store.select(PipelinedetailsStoreSelectors.getAllPipelinedetails);
  }

  get clearPipelinedetails() {
    this.store.dispatch(PipelinedetailsStoreActions.clearPipelinedetails());
    return this.store.select(PipelinedetailsStoreSelectors.getAllPipelinedetails);
  }

  fetchStudentRecord(query) {
    this.store.dispatch(
      PipelinedetailsStoreActions.fetchPipelinedetailsRecord({ fetch: query }),
    );
  }

  fetchByIdStudentRecord(id: string) {
    this.store.dispatch(
      PipelinedetailsStoreActions.fetchByIdPipelinedetailsRecord({ id }),
    );
  }

  searchPipelinedetails(query) {
    this.store.dispatch(
      PipelinedetailsStoreActions.searchPipelinedetailsRecord({
        query,
      }),
    );
  }

  findPipelinedetails(query) {
    this.store.dispatch(
      PipelinedetailsStoreActions.searchPipelinedetailsIdRecord({
        query,
      }),
    );
  }

  addPipelinedetails(newPipelinedetails: PipelineDetailsDto) {
    this.store.dispatch(
      PipelinedetailsStoreActions.addPipelinedetails({
        newPipelinedetails,
      }),
    );
    return this.store.select(PipelinedetailsStoreSelectors.loadingPipelinedetails);
  }

  updatePipelinedetails(updatePipelinedetails: PipelineDetailsDto) {
    this.store.dispatch(
      PipelinedetailsStoreActions.updatePipelinedetails({
        updatePipelinedetails,
      }),
    );
    return this.store.select(PipelinedetailsStoreSelectors.loadingPipelinedetails);
  }

  removePipelinedetails(id: string) {
    this.store.dispatch(PipelinedetailsStoreActions.removePipelinedetails({ id }));
  }
}